import React, { useEffect, useRef, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import Breadcrumbs from '../components/Breadcrumbs';
import TopFilter from '../components/TopFilter';
import RightFilterToggle from '../components/RightFilterToggle';
import paginationFactory from 'react-bootstrap-table2-paginator';
import GridData from '../components/gridmodal/GridDataPackages';
// import { propTypes } from 'react-bootstrap/esm/Image';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import filterFactory, { textFilter, customFilter } from 'react-bootstrap-table2-filter';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.css';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
// import PriceFilter from '../components/CustomGridFilter';
import configData from '../configData.json';
import { format } from 'date-fns';
import Spinner from 'react-bootstrap/Spinner';
import ColumnFilter from '../components/ColumnFilter';
import { Link } from 'react-router-dom';
import LeftMenu from '../components/LeftMenu';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';
import GridDataPackages from '../components/gridmodal/GridDataPackages';
import MycustomDesignGrid from '../components/MycustomDesignGrid';
import TpSearchRightFilterToggle from '../components/TpSearchRightFilterToggle';
import Select from 'react-select';
import GridDataTpSearch from '../components/gridmodal/GridDataTpSearch';


export default function TransportationProviderSearch() {

    const [TpSearchBills, setTpSearchBills] = useState([]);
    const [DetailByCarr, setDetailData] = useState([]);
    const [selectedSummaryRow, setSelectedRow] = useState({});

    const [hidden, setHidden] = useState(true);

    const { ExportCSVButton } = CSVExport;


    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(1);

    const [prevY, setPrevY] = useState(0);

    let prevYRef = useRef({});
    let selectedRowRef = useRef({});
    let DetailByCarrRef = useRef({});
    let hiddenRef = useRef({});
    let pageRef = useRef({});

    prevYRef.current = prevY;
    selectedRowRef.current = selectedSummaryRow;
    DetailByCarrRef.current = DetailByCarr;
    hiddenRef.current = hidden;
    pageRef.current = page;

    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
      
    const searchOnClick = (carriersValues) => {
        LoadSummaryData(carriersValues);
    }

    const LoadSummaryData = async (carriersValues) => {

        setLoading(true);
        setTpSearchBills([]);
        const URL = `${configData.BASE_APP_URL}FreightBill/GetBillCountByCarrierOwnerSummary/${carriersValues}`;
        console.log(URL);
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => setTpSearchBills(resp));
        setLoading(false);
    }

    const LoadDetailData = async (carrierKey, setLoadingFunc) => {
        debugger;
        setLoadingFunc(true);
        setDetailData([]);
        const URL = `${configData.BASE_APP_URL}FreightBill/GetBillCountByCarrierOwnerDetails/${carrierKey}`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => {
                setDetailData(resp);
                //OpenPopup();
                setHidden(false);
            })
        setLoadingFunc(false);
    }

    const columnFormatter = (cell, row, rowIndex, formatExtraData) => {
        return (
            <div>
                <span><a href='#'><i className="fa fa-expand mr-1"></i></a>{row.carrierName}</span>
            </div>
        )
    }

    const numberFormatter = (cell, row, rowIndex, formatExtraData) => {
        return (
            <div>
                <span>{parseFloat(cell).toLocaleString('en-US')}</span>
            </div>
        );
    }

    const csvnumberFormatter = (cell, row, rowIndex, formatExtraData) => {
        return parseFloat(cell).toLocaleString('en-US');
    };


    const columnsDetail = [
        {
            dataField: 'ownerName',
            text: 'Owner Name',
            headerStyle: { width: '12px', textAlign: 'center' },
            align: 'left',
            sort: true,
            // csvFormatter: freightBillFormattercsv,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'customerName',
            text: 'Customer Name',
            headerStyle: { width: '35px', textAlign: 'center' },
            align: 'left',
            sort: true,
            // csvFormatter: invoicenumberFormattercsv,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />
        },
        {
            dataField: 'totalCount',
            text: 'Total Number of Bills',
            headerStyle: { width: '10px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: numberFormatter,
            csvFormatter: csvnumberFormatter
        },
        {
            dataField: 'manualCount',
            text: 'Manual Data Entry Count',
            headerStyle: { width: '10px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: numberFormatter,
            csvFormatter: csvnumberFormatter
        },
        {
            dataField: 'ocrCount',
            text: 'OCR Data Entry Count',
            headerStyle: { width: '10px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: numberFormatter,
            csvFormatter: csvnumberFormatter
        },
        {
            dataField: 'ediCount',
            text: 'EDI Count',
            headerStyle: { width: '10px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: numberFormatter,
            csvFormatter: csvnumberFormatter
        }
    ]


    const columns = [
        {
            dataField: 'id',
            text: 'Id',
            headerStyle: { width: '50' },
            hidden: true,
            csvExport: false,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />
        },
        {
            dataField: 'carrierKey',
            text: 'CarrierKey',
            headerStyle: { width: '65px', textAlign: 'center' },
            hidden: true,
            csvExport: false
        },
        {
            dataField: 'carrierName',
            text: 'Transportation Provider Name',
            headerStyle: { width: '250px', textAlign: 'center' },
            filter: customFilter(),
            sort: true,
            formatter: columnFormatter,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    setDetailData([]);
                    setPage(1);
                    const selectedRow = {
                        carrierKey: row.carrierKey,
                        carrierSCACCode: row.carrierSCACCode,
                        carrierName: row.carrierName,
                        totalCount: row.totalCount,
                        pkgCount: row.pkgCount
                    }
                    setSelectedRow(selectedRow);
                    LoadDetailData(row.carrierKey, setLoading);
                }
            },
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />


        },
        {
            dataField: 'carrierSCACCode',
            text: 'SCAC Code',
            headerStyle: { width: '65px', textAlign: 'center' },
            filter: customFilter(),
            sort: true,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />


        },
        {
            dataField: 'totalCount',
            text: 'Total Number of Bills Processed',
            headerStyle: { width: '65px', textAlign: 'center' },
            align: 'right',
            filter: customFilter(),
            sort: true,
            formatter: numberFormatter,
            csvFormatter: csvnumberFormatter,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />


        }

    ];

    const sizePerPageRenderer = ({
        options,
        currSizePerPage,
        onSizePerPageChange
    }) => (
        <div className="btn-group" role="group">
            {
                options.map((option) => {
                    const isSelect = currSizePerPage === `${option.page}`;
                    return (
                        <button
                            key={option.text}
                            type="button"
                            onClick={() => onSizePerPageChange(option.page)}
                            className={`btn ${isSelect ? 'btn-secondary' : 'btn-warning'}`}
                        >
                            {option.text}
                        </button>
                    );
                })
            }
        </div>
    );

    const options = {
        sizePerPageRenderer,
        sizePerPageList: [{
            text: '50', value: 50
        }, {
            text: '100', value: 100
        },
        {
            text: '200', value: 200
        }, {
            text: 'All', value: TpSearchBills.length
        }]
    };

    const detailOptions = {
        sizePerPageRenderer,
        sizePerPageList: [
            {
                text: '50', value: 50
            }, {
                text: '100', value: 100
            },
            {
                text: '200', value: 200
            },
            {
                text: 'All', value: DetailByCarr.length
            }
        ]


    };

    const DownloadSummaryData = async () => {
        const URL = `${configData.BASE_APP_URL}FreightBill/GenerateExcelForTransportationProviderSummaryReport`;
        // console.log(URL);

        const response = await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('my-token')
            },
            body: JSON.stringify({ data: TpSearchBills }),
            responseType: 'blob'
        });

        const data = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = `Transportation Provider Search.xlsx`;
        link.click();
    };

    const DownloadDetailData = async () => {
        const URL = `${configData.BASE_APP_URL}FreightBill/GenerateExcelForTransportationProviderDetailReport`;
        // console.log(URL);

        const response = await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('my-token')
            },
            body: JSON.stringify({ data: DetailByCarrRef.current }),
            responseType: 'blob'
        });

        const data = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = `Transportation Provider Search Detail.xlsx`;
        link.click();
    };

    const breadcumTitle = <div dangerouslySetInnerHTML={{ __html: 'Transportation Provider Search' }} />;

    return (
        <>
            <div className='st1'>
                <LeftMenu />
                <div className="mcw">
                    <TopBar />
                    <div className='pt-1 px-3 pb-3 py-3'>
                        <div className='floating-table-overlay' hidden={hidden}></div>
                        <div hidden={hidden} className="floating-table shadow-sm full-height-modal">
                            <div className='row g-0 p-2 bg-white'>
                                <button onClick={() => setHidden(!hidden)} className='close-modal'><i className="fas fa-times"></i></button>
                                <GridDataTpSearch data={selectedRowRef.current} />
                            </div>
                            <div className='border-top p-2 table-container'>
                                <div className='custom-table-text'>
                                    {DetailByCarr.length > 0 ?
                                        <ToolkitProvider
                                            keyField="CarrierKey"
                                            data={DetailByCarr}
                                            columns={columnsDetail}
                                            exportCSV={{fileName: 'Transportation Search Detail.csv'}}>
                                            {
                                                props => (
                                                    <div>
                                                        {/* <div className='sticky-sm-top'> */}

                                                        {/* </div> */}
                                                        <BootstrapTable
                                                            classes='table table-striped table-hover table-width-small'
                                                            headerClasses='table-top'
                                                            bootstrap4
                                                            pagination={paginationFactory(detailOptions)}
                                                            keyField='freightBillKey'
                                                            data={DetailByCarrRef.current}
                                                            columns={columnsDetail}
                                                            {...props.baseProps}
                                                            filter={filterFactory()}
                                                        />
                                                        <button className='btn react-bs-table-csv-btn' onClick={DownloadDetailData}><i className='fa fa-download'></i> Export
                                                        </button>
                                                        {/* <ExportCSVButton {...props.csvProps}><i className='fa fa-download'></i>Export</ExportCSVButton> */}

                                                    </div>
                                                )
                                            }
                                        </ToolkitProvider>
                                        : <>
                                            <MycustomDesignGrid column={columnsDetail} />
                                        </>}
                                </div>
                            </div>
                        </div>
                        {/* <Breadcrumbs title="Invoice Status (Freight Bill Status Report)" /> */}
                        <Breadcrumbs title={breadcumTitle} />
                        {loading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : loading}
                        <div className='d-flex'>
                            <div className="table-container">
                                <div className='grid-toggle'>
                                    <div className='main-table-text dropup'>
                                        {TpSearchBills.length > 0 ?
                                            <ToolkitProvider
                                                keyField="id"
                                                data={TpSearchBills}
                                                columns={columns}
                                                exportCSV={{fileName: 'Transportation Provider Search Summary.csv'}}>
                                                {
                                                    props => (
                                                        <div>
                                                            {/* <div style={{ backgroundColor: '#fff', marginTop: '5px', textAlign: 'right' }}>
                                                                <ExportCSVButton {...props.csvProps}><i className='fa fa-download'></i> Export </ExportCSVButton>
                                                            </div> */}
                                                            <div style={{ backgroundColor: '#fff', marginTop: '5px', textAlign: "right" }}>
                                                                <button className='btn react-bs-table-csv-btn' onClick={DownloadSummaryData}><i className='fa fa-download'></i> Export
                                                                </button>
                                                            </div>
                                                            <BootstrapTable
                                                                classes='table table-striped table-hover table-width'
                                                                headerClasses='table-top'
                                                                bootstrap4
                                                                pagination={paginationFactory(options)}
                                                                {...props.baseProps}
                                                                filter={filterFactory()}
                                                            />
                                                            {/* <ExportCSVButton {...props.csvProps}><i className='fa fa-download'></i> Export</ExportCSVButton> */}
                                                        </div>
                                                    )
                                                }
                                            </ToolkitProvider> : <>
                                                <MycustomDesignGrid column={columns} />
                                            </>}
                                    </div>
                                </div>
                            </div>
                            <TpSearchRightFilterToggle onSearchClick={searchOnClick} />
                        </div>
                    </div>
                    <Footer />
                </div>
            </div >
        </>
    )
}